import React, { useState } from "react"
import { FormControl, InputLabel, Select, MenuItem } from "@mui/material"

const modernSelectSx = {
  borderRadius: "10px",
  backgroundColor: "#fff",
  "& .MuiOutlinedInput-notchedOutline": {
    borderColor: "#D8DDE6"
  },
  "&:hover .MuiOutlinedInput-notchedOutline": {
    borderColor: "#AEB6C3"
  },
  "&.Mui-focused": {
    boxShadow: "none"
  },
  "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
    borderColor: "#1976D2",
    borderWidth: 1
  }
}

const modernLabelSx = {
  color: "#68717D",
  fontWeight: 500,
  "&.Mui-focused": {
    color: "#1976D2"
  }
}

const modernMenuProps = {
  PaperProps: {
    elevation: 0,
    sx: {
      mt: 1,
      borderRadius: "10px",
      border: "1px solid #E5E7EB",
      boxShadow: "0 12px 28px rgba(15, 23, 42, 0.12)",
      overflow: "hidden",
      "& .MuiList-root": {
        py: 0.75
      },
      "& .MuiMenuItem-root": {
        mx: 0.75,
        my: 0.25,
        px: 1.5,
        py: 1.1,
        borderRadius: "8px",
        color: "#2F3744",
        fontSize: "0.95rem",
        transition: "background-color 160ms ease, transform 160ms ease",
        "&:hover": {
          backgroundColor: "#F1F4F8",
          transform: "translateX(2px)"
        },
        "&.Mui-selected": {
          backgroundColor: "#EEF5FF",
          color: "#1976D2",
          fontWeight: 700
        }
      }
    }
  }
}

const mergeSx = (...items) => items.filter(Boolean)

const getMenuProps = menuProps => ({
  ...modernMenuProps,
  ...menuProps,
  PaperProps: {
    ...modernMenuProps.PaperProps,
    ...menuProps?.PaperProps,
    sx: {
      ...modernMenuProps.PaperProps.sx,
      ...menuProps?.PaperProps?.sx
    }
  }
})

const SelectOption = ({
  name,
  label,
  value,
  onChange,
  data,
  style,
  size,
  selectCss,
  labelStyle,
  onFocus,
  onScroll,
  fieldNames,
  ...props
}) => {
  const { MenuProps, ...selectProps } = props
  if (data[0] && Object.keys(data[0])?.length > 2) {
    const fieldWithLabel = Object.keys(data[0]).find(field => field === "title" || field === "name")
    if (fieldWithLabel) {
      fieldNames = { value: "_id", name: fieldWithLabel }
    }
  }
  //console.log(data,"gfhj");
  return (
    <FormControl size={size} sx={style}>
      <InputLabel sx={mergeSx(modernLabelSx, labelStyle)} id={name}>
        {label}
      </InputLabel>
      <Select
        labelId={name}
        id={name}
        value={value || ""}
        name={name}
        label={label}
        onChange={onChange}
        sx={mergeSx(modernSelectSx, selectCss)}
        MenuProps={getMenuProps(MenuProps)}
        required
        onFocus={onFocus}
        {...selectProps}
      >
        {fieldNames
          ? data?.map((info, index) => {
              return (
                <MenuItem key={index} value={info[fieldNames.value]}>
                  {info[fieldNames.name]}
                </MenuItem>
              )
            })
          : data?.map((info, index) => {
              const values = Object.values(info)
              return (
                <MenuItem key={index} value={values[0]}>
                  {values[1]}
                </MenuItem>
              )
            })}
      </Select>
    </FormControl>
  )
}
const SelectOptionEdit = ({
  name,
  label,
  value,
  onChange,
  data,
  style,
  size,
  selectCss,
  labelStyle,
  onFocus,
  onScroll,
  defaultSelected,
  required,
  fieldNames,
  ...props
}) => {
  const { MenuProps, ...selectProps } = props
  // ={value:"id",name:"name"}
  const [focus, setFocus] = useState(false)
  if (data[0] && Object.keys(data[0])?.length === 2) {
    const fieldWithLabel = Object.keys(data[0]).find(field => field === "title" || field === "name")
    if (fieldWithLabel) {
      fieldNames = { value: "_id", name: fieldWithLabel }
    }
  }

  return (
    <FormControl size={size} sx={style}>
      <InputLabel sx={mergeSx(modernLabelSx, labelStyle)} id={name}>
        {value || focus ? label : defaultSelected}
      </InputLabel>
      <Select
        labelId={name}
        id={name}
        value={value || ""}
        name={name}
        label={label}
        onChange={onChange}
        sx={mergeSx(modernSelectSx, selectCss)}
        MenuProps={getMenuProps(MenuProps)}
        onFocus={() => {
          if (onFocus) onFocus()
          !value && setFocus(true)
        }}
        onBlur={() => !value && setFocus(false)}
        {...selectProps}
      >
        {fieldNames
          ? data?.map((info, index) => {
              const values = Object.values(info)
              return (
                <MenuItem key={index} value={info[fieldNames.value]}>
                  {info[fieldNames.name]}
                </MenuItem>
              )
            })
          : data?.map((info, index) => {
              const values = Object.values(info)
              return (
                <MenuItem key={index} value={values[0]}>
                  {values[1]}
                </MenuItem>
              )
            })}
      </Select>
    </FormControl>
  )
}

export { SelectOptionEdit }
export default SelectOption
